export default "__VITE_ASSET__BGzeCdn9__"